import { Component, OnInit, Input, ElementRef } from '@angular/core';
import { trigger, state, animate, transition, style } from '@angular/animations';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { EBEpouchdbService } from '../../../EBE/EBEpouchdb.service';
import { ELEpouchdbService } from '../../../ELE/ELE.pouchdb.service';
import { Page } from '../../../shared/models/page';
import { Notesdata } from '../../../shared/models/Notesdata';
import * as _ from 'lodash'
import { LanguageTranslateObservableService } from '../../../shared/languageTranslateObservable.service';
import { SimpleChanges } from '@angular/core/src/metadata/lifecycle_hooks';

@Component({
  selector: 'app-Note',
  templateUrl: './Note.component.html',
  styleUrls: ['./Note.component.css'],
  animations: [
    trigger('show', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate(300, style({ opacity: 1 }))
      ]),
      transition(':leave', [
        style({ opacity: 1 }),
        animate(300, style({ opacity: 0 }))
      ])
    ]),
    trigger('rotatedState', [
      state('default', style({ transform: 'rotate(0)' })),
      state('rotated', style({ transform: 'rotate(45deg)' })),
      transition('rotated => default', animate('300ms ease-out')),
      transition('default => rotated', animate('300ms ease-in'))
    ]),
  ],
})

export class NoteComponent implements OnInit {
  @Input() data: any;
  currentPageDataObj;
  bookDataObj;
  selectedTab;
  shownotes = true;
  showaddnotes = false
  filpToggleIcon = ' icon-Note-Turn-R-L';
  selectedcolor = '#efe398';
  showright = true;
  showleft = false;
  showblankpage;
  rotateState;
  ccolour = '#e5d05c';

  Colorcode: any = [{

    'value': '#efe398',
    'ccolour': '#e5d05c',
    'showToggleIcon': false
  }, {

    'value': '#d7f9a9',
    'ccolour': '#b6ee6a',
    'showToggleIcon': false
  },
  {

    'value': '#a1ccf5',
    'ccolour': '#6db1f0',
    'showToggleIcon': false
  }, {

    'value': '#f9a5d5',
    'ccolour': '#f77bc1',
    'showToggleIcon': false
  },
  {

    'value': '#dbabef',
    'ccolour': '#ca84e7',
    'showToggleIcon': false

  },
  {

    'value': '#ffffff',
    'ccolour': '#e2e2e2',
    'showToggleIcon': false
  }

  ]
  noteindex
  currentPageData
  Notelist
  Notefilter
  sample = "sample";
  Isdisable
  cLanguage;
  constructor(public pouchService: EBEpouchdbService, private ele: ElementRef, public ElepouchService: ELEpouchdbService, private languageTranslateObservableService: LanguageTranslateObservableService) { }

  ngOnInit() {

    this.cLanguage = this.languageTranslateObservableService.selectedLang;

    this.pouchService.notesDataebe$.subscribe(evt => {
      this.sample
      if (this.title != "") {
        this.Addnotes();
      }
    });
    this.ElepouchService.notesData$.subscribe(evt => {
      this.sample
      if (this.title != "") {
        this.Addnotes();
      }
    });
    this.Isdisable = false
    try {
      this.currentPageDataObj = this.data.popupProps.currentPageDataObj

      this.bookDataObj = this.data.popupProps.bookDataObj
      this.currentPageData = this.bookDataObj[this.currentPageDataObj]


      this.Notelist = this.currentPageData.notes
      this.Notefilter = this.currentPageData.notes
      if (this.currentPageDataObj.length == 0) {
        this.showblankpage = true
      }
    }

    catch (ex) {

    }
  }


  createNewBookOptions() {

    this.shownotes = false;
    this.showaddnotes = true;
    this.rotate()

  }


  title = ""
  descrptionshort = ""
  mydata(data) {
    this.title = data.innerText
    this.ele.nativeElement.querySelector('.inputTypeNote').innerText = this.title

  }
  mydatashort(write) {
    this.descrptionshort = write.innerText
    this.ele.nativeElement.querySelector('.inputTypeFlipNote').innerText = this.descrptionshort

  }
  rotate() {
    this.rotateState = (this.rotateState == 'default' ? 'default' : 'default');
    this.update = false

  }
  selectedindex = '0';
  clickClrPickerBox(value, i) {
    this.selectedcolor = value.value
    this.ccolour = value.ccolour
    this.selectedindex = i
  }
  selectedTabs = -1;
  Titlenote = "Add Note"
  displayGridViewForFolderfolderLEFT() {

    this.Isdisable = false
    this.showright = true;
    this.Titlenote = "Add Note"
    try {
      setTimeout(() => {
        this.ele.nativeElement.querySelector('.inputTypeNote').innerText = this.title
      }, 10);
    }
    catch (ex) {

    }
    setTimeout(() => {
      this.ele.nativeElement.querySelector('.inputTypeFlipNote').innerText = this.descrptionshort
    }, 10);

  }
  displayGridViewForFolderfolderright() {
    this.Titlenote = "Short Description"
    this.Isdisable = true
    this.filpToggleIcon = 'icon-Note-Turn-R-L';
    this.showright = false;
    try {
      setTimeout(() => {
        this.ele.nativeElement.querySelector('.inputTypeFlipNote').innerText = this.descrptionshort
      }, 10);

    }
    catch (ex) {

    }
    setTimeout(() => {
      this.ele.nativeElement.querySelector('.inputTypeNote').innerText = this.title
    }, 10);
  }
  displayGridViewForFolderfolder() {
    if (this.filpToggleIcon == 'icon-Note-Turn-R-L') {
      this.filpToggleIcon = 'icon-Note-Turn-L-R';
      this.ele.nativeElement.querySelector('.inputTypeNote').innerText = this.title
      // this.Isdisable=false
      this.showright = false;
      this.Titlenote = "Add Note"

      setTimeout(() => {
        this.ele.nativeElement.querySelector('.inputTypeFlipNote').innerText = this.descrptionshort
      }, 10);


    } else {
      this.Titlenote = "Short Description"
      // this.Isdisable=true
      this.filpToggleIcon = 'icon-Note-Turn-R-L';
      this.showright = true;
      this.ele.nativeElement.querySelector('.inputTypeFlipNote').innerText = this.descrptionshort

      setTimeout(() => {
        this.ele.nativeElement.querySelector('.inputTypeNote').innerText = this.title
      }, 10);


    }
  }
  backtoshownote() {
    this.shownotes = true;
    this.showaddnotes = false;

    if (this.title != "") {
      this.Addnotes();
    }
    this.Notelist = this.currentPageData.notes
    for (var i = 0; i < this.Colorcode.length; i++) {

      this.Colorcode[i].showToggleIcon = false;

    }
  }
  previousindex
  filternotes(colour, index) {
    ;
    //this.Colorcode[this.previousindex].showToggleIcon="";

    if (index == 7) {
      for (var i = 0; i < this.Colorcode.length; i++) {
        this.Colorcode[i].showToggleIcon = false;
      }
      this.Notelist = this.currentPageData.notes
    }
    else {

      //this.Colorcode[index].showToggleIcon=!this.Colorcode[index].showToggleIcon;
      if (this.Colorcode[index] && this.Colorcode[index].isValid != undefined) {
        this.Colorcode[index].showToggleIcon = !this.Colorcode[index].showToggleIcon;
      }
      if (this.Colorcode[index].showToggleIcon == true) {
        this.Colorcode[index].showToggleIcon = false;
        this.Notelist = this.currentPageData.notes
      }
      else {
        for (var i = 0; i < this.Colorcode.length; i++) {
          if (index == i) {
            this.Colorcode[i].showToggleIcon = true;
          } else {
            this.Colorcode[i].showToggleIcon = false;
          }
        }
        var r = this.currentPageData.notes
        this.Notelist = _.filter(r, function (o) {
          return o.rectangle == index;
        });
      }
    }
  }
  Addnotes() {

    var page: Page = new Page();
    var notes: Notesdata = new Notesdata()
    notes.title = this.title
    notes.description = this.descrptionshort
    notes.rectangle = this.selectedindex
    if (!this.update) {


      page.id = this.currentPageDataObj.id;
      page.notes.push(notes)
      this.bookDataObj[this.currentPageDataObj].notes.push(notes);


    }
    else {

      this.bookDataObj[this.currentPageDataObj].notes[this.noteindex] = notes
      // var bookobj=this.bookDataObj
      // this.pouchService.updatenoteobj(bookobj,this);
      // this.data.popupProps.curComp.pageNotesLength=this.bookDataObj[this.currentPageDataObj].notes.length
    }
    var bookobj = this.bookDataObj
    this.pouchService.updatenoteobj(bookobj, this);
    this.data.popupProps.curComp.pageNotesLength = this.bookDataObj[this.currentPageDataObj].notes.length

    this.showright = true;
    this.showleft = false;
    this.title = ""
    this.descrptionshort = "";
    this.selectedindex = "";
  }
  update = false
  selectednotes(data, index) {
    this.noteindex = index
    this.update = true
    this.showaddnotes = true
    this.shownotes = false;
    this.showright = true;
    this.descrptionshort = data.description;
    this.title = data.title;
    this.Isdisable = false;
    setTimeout(() => {
      this.ele.nativeElement.querySelector('.inputTypeNote').innerText = data.title;

    }, 10);
    this.selectedindex = data.rectangle
    var r = this.Colorcode[data.rectangle];
    this.selectedcolor = r.value
    this.ccolour = r.ccolour


  }
  viewnotescreen() {
    this.ele.nativeElement.querySelector('.inputTypeNote').innerText = "";
    this.ele.nativeElement.querySelector('.inputTypeFlipNote').innerText = "";
    this.shownotes = true;
    this.showaddnotes = false;
    // this.bookDataObj[this.currentPageDataObj].notes.push({
    //   'title':this.title,
    //   'description':this.descrptionshort,
    //   'rectangle':this.selectedindex

    // })
  }
  checkNoOfChar(evt, char) {
    if (char && char.innerText.length > 99) {
      evt.preventDefault();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/bookShared/popups/Note/Note.component.ts